import React, { useEffect, useState } from "react";
import {
  Breadcrumbs,
  createStyles,
  Button,
  TextInput,
  Container,
} from "@mantine/core";
import { Search } from "../Svg";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

const useStyles = createStyles((theme) => ({
  root: {
    color: "white",
    fontSize: "16px",
    lineHeight: "25px",
    textDecoration: "none",
  },
  separator: {
    color: "white",
    fontSize: "16px",
  },
}));

const CPageHeader = ({
  title,
  links,
  subTitle,
  showInput = true,
  Inputplaceholder,
  onSearch = () => {},
  dictionary,
}) => {
  const { classes, theme } = useStyles();
  const searchParams = useSearchParams();
  const [search, setSearch] = useState("");

  useEffect(() => {
    setSearch(searchParams.get("search") ?? "");
  }, [searchParams]);

  const breadLinks = links.map((item, index) =>
    item.href ? (
      <Link key={index} className={classes.root} href={item.href}>
        {item.title}
      </Link>
    ) : (
      <span key={index} className={`${classes.root} hover:cursor-pointer`}>
        {item.title}
      </span>
    )
  );

  return (
    <section className="bg-gradient-to-r from-lightPrimary to-darkPrimary ">
      <Container className="relative min-h-[300px] flex flex-col items-center justify-center">
        <h1 className="text-3xl md:text-5xl text-white font-extrabold m-0 ">
          {title}
        </h1>
        <h2 className="text-white m-0 my-3 text-[18px] md:text-[20px] font-normal max-w-[600px] text-center">
          {subTitle}
        </h2>
        <Breadcrumbs
          className="my-3 mb-4 font-bold absolute top-5 left-3"
          classNames={{
            separator: classes.separator,
          }}
        >
          {breadLinks}
        </Breadcrumbs>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSearch(search);
          }}
        >
          {showInput == true ? (
            <TextInput
              value={search}
              icon={<Search width="18" height="18" />}
              variant="filled"
              placeholder={Inputplaceholder ?? dictionary?.enterNameOrKeyword}
              styles={{
                input: {
                  paddingRight: "118px",
                  ":placeholder": {
                    fontSize: "10px !important",
                    lineHeight: "19px",
                    fontWeight: "500",
                    color: theme.colors.textGrey,
                  },
                },
                icon: {
                  color: theme.colors.textGrey,
                },
              }}
              radius="md"
              className="search-input placeholder-18 sm:w-[400px] md:w-[600px] lg:w-[800px] "
              size="xl"
              rightSection={
                <Button
                  className="me-14"
                  variant="gradient"
                  onClick={() => {
                    onSearch(search);
                  }}
                >
                  {dictionary?.search}
                </Button>
              }
              onChange={(e) => setSearch(e.target.value)}
            />
          ) : null}
        </form>
      </Container>
    </section>
  );
};
export default CPageHeader;
